import { render, staticRenderFns } from "./gbbd_more.vue?vue&type=template&id=128dfdc8&"
import script from "./gbbd_more.vue?vue&type=script&lang=js&"
export * from "./gbbd_more.vue?vue&type=script&lang=js&"
import style0 from "./gbbd_more.vue?vue&type=style&index=0&id=128dfdc8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports